import { DetailsInfo, Text } from '@/components';
import {
  AbilityLabelModifier,
  PermissionTypeLabelModifier,
  type RoleModel,
} from '@/features/tenant-manager/role/_models/role';
import { datetimeFormat } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type Props = {
  role: z.infer<typeof RoleModel>;
};

export const RoleDetails: FC<Props> = ({ role }) => {
  const { t } = useTranslation();
  return (
    <DetailsInfo
      items={[
        {
          label: t('name'),
          value: <Text weight="regular" text={role.name} />,
        },
        {
          label: t('project-management'),
          value: (
            <Text
              weight="regular"
              text={
                PermissionTypeLabelModifier[
                  role.resourceGroupPermissions.project
                ]
              }
            />
          ),
        },
        {
          label: t('indicator-management'),
          value: (
            <Text
              weight="regular"
              text={
                PermissionTypeLabelModifier[
                  role.resourceGroupPermissions.indicator
                ]
              }
            />
          ),
        },
        {
          label: t('scope-tag-management', { scope: t('global-tag') }),
          value: (
            <Text
              weight="regular"
              text={
                PermissionTypeLabelModifier[
                  role.resourceGroupPermissions.globalTag
                ]
              }
            />
          ),
        },
        {
          label: t('scope-tag-management', { scope: t('local-tag') }),
          value: (
            <Text
              weight="regular"
              text={
                PermissionTypeLabelModifier[
                  role.resourceGroupPermissions.localTag
                ]
              }
            />
          ),
        },
        {
          label: t('master-table-management'),
          value: (
            <Text
              weight="regular"
              text={
                PermissionTypeLabelModifier[
                  role.resourceGroupPermissions.masterTable
                ]
              }
            />
          ),
        },

        {
          label: t('administrator'),
          value: (
            <Text
              weight="regular"
              text={
                PermissionTypeLabelModifier[
                  role.resourceGroupPermissions.administrator
                ]
              }
            />
          ),
        },
        {
          label: t('continue-ability'),
          value: (
            <Text
              weight="regular"
              text={AbilityLabelModifier[role.continueAbility.toString()]}
            />
          ),
        },
        {
          label: t('lock-project'),
          value: (
            <Text
              weight="regular"
              text={AbilityLabelModifier[role.lockAbility.toString()]}
            />
          ),
        },
        {
          label: t('template-management'),
          value: (
            <Text
              weight="regular"
              text={AbilityLabelModifier[role.templateAbility.toString()]}
            />
          ),
        },
        {
          label: t('publish-ability'),
          value: (
            <Text
              weight="regular"
              text={AbilityLabelModifier[role.publishAbility.toString()]}
            />
          ),
        },
        {
          label: t('created-datetime'),
          value: (
            <Text
              weight="regular"
              text={datetimeFormat({ datetime: role.createdAt })}
            />
          ),
        },
        {
          label: t('updated-datetime'),
          value: (
            <Text
              weight="regular"
              text={datetimeFormat({ datetime: role.updatedAt })}
            />
          ),
        },
      ]}
    />
  );
};
